function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationRuleTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db8509"
    },
    d: "M28 35.746c0 2.211-1.79 4-4 4s-4-1.789-4-4a4 4 0 0 1 8 0zM26 11a1.999 1.999 0 1 1-4 0V7a1.999 1.999 0 1 1 4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc107"
    },
    d: "M33 33V16.8a9 9 0 0 0-9-9 9 9 0 0 0-9 9V33Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc107"
    },
    d: "M41 33c0 2.21-7.059 4-17 4-9.941 0-17-1.79-17-4s7.059-4 17-4c9.941 0 17 1.79 17 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc107"
    },
    d: "M7 33c0-2 8-9 8-12s18-3 18 0 8 10 8 12-34 2-34 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffe8a0",
      fillOpacity: 1,
      strokeWidth: 1.12972438
    },
    d: "M10.746 27.666c-.817.968-.81.97-1.613 1.932 1.467.926 7.646 4.539 15.261 4.539 4.296 0 9.433-1.504 14.308-4.727-.867-1.047-.87-1.053-1.542-1.836-11.801 7.448-23.313 1.86-26.414.092z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 172V0h172v172z",
    style: {
      fill: "none"
    },
    transform: "translate(24 22) scale(.13953)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2015.6 899.2c19.5 19.5 42.5 35 67.9 45.8 53 22.2 112.7 22.2 165.8 0 51.2-21.8 92-62.5 113.7-113.7 22.2-53 22.2-112.7 0-165.8-21.8-51.2-62.5-92-113.7-113.7-53-22.2-112.7-22.2-165.8 0-51.2 21.8-92 62.5-113.7 113.7-22.2 53-22.2 112.7 0 165.8 10.8 25.3 26.4 48.4 45.8 67.9zm-62.4 197.8v642.1h107c36.8-.2 73.4-3.6 109.5-10.4 36.3-6.4 71.3-18.6 103.7-36.2 30.6-16.6 57-40 77.3-68.2 21.3-31.3 32-68.6 30.5-106.5V1097Zm-346.8-269.2c28.4.2 56.6-5.5 82.8-16.7 51.2-21.8 91.9-62.5 113.6-113.7 22.2-53 22.2-112.7-.1-165.8-21.8-51.2-62.5-92-113.7-113.7-26.2-11.2-54.4-16.9-82.9-16.7-28.3-.2-56.3 5.5-82.3 16.7-19.4 8.3-25.5 19.1-52.2 32.1v329c26.8 13.1 32.8 23.8 52.2 32.1 26.1 11.3 54.2 16.9 82.6 16.7zm-134.8 1081.1c26.8 5.8 36.4 10.3 55.4 12.9 20.8 3 41.8 4.5 62.8 4.6 32.4-.2 64.8-3.6 96.5-10.4 32.3-6.5 63.3-18.6 91.5-35.7 27.7-17 51-40.2 68.2-67.7 19-32.1 28.3-69.1 26.9-106.4v-743h-401.3ZM0 2113.7l1391.3 240.8V0L0 240.8Z",
    className: "st0",
    style: {
      fill: "#5558af"
    },
    transform: "translate(26 24.248) scale(.00924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1016.7 722.4-642.1 39.1v148.1l240.8-9.7v686.7l160.5 9.4V893.6l240.8-10.7z",
    className: "st1",
    style: {
      fill: "#fff"
    },
    transform: "translate(26 24.248) scale(.00924)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationRuleTeams);
export default __webpack_public_path__ + "static/media/notificationRuleTeams.46f0a5ccef615f377161e7a651448f7d.svg";
export { ForwardRef as ReactComponent };